<template>
  <layout>
    <template v-slot:title>Logout</template>
    <p>Are you sure you want to log out from Sharedo?</p>
    <form-buttons>
      <button type="button" class="btn btn-primary" @click="yesClicked">
        Yes
      </button>
      <router-link to="/" class="btn btn-secondary">No</router-link>
    </form-buttons>
  </layout>
</template>
<script>
import auth from "@/services/auth/authService";

const yesClicked = function() {
  auth.logout().then(() => {
    this.logInfo("User has successfully logged out.");
    this.$router.push({ path: "/landing", query: { nologon: true } });
  });
};

export default {
  methods: {
    yesClicked,
  },
};
</script>
